import React from "react";

const CommunityAvatar: React.FC<{
  logo?: string;
  label?: string;
  size: "sm" | "md";
}> = ({ logo, label, size }) => {
  const sizeClass = size === "sm" ? "h-8 w-8" : "h-9 w-9 sm:h-10 sm:w-10";
  const initial = (label || "?").charAt(0).toUpperCase();

  if (logo) {
    return (
      <img
        src={logo}
        alt={label || "Community"}
        className={`${sizeClass} rounded-full object-scale-down bg-white border border-gray-200 flex-shrink-0`}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full bg-gray-200 border border-gray-200 flex items-center justify-center flex-shrink-0`}
    >
      <span className="text-xs sm:text-sm font-semibold text-gray-600">{initial}</span>
    </div>
  );
};

export default CommunityAvatar;
